// extracted by mini-css-extract-plugin
export default {"WrapperAnswer":"TestQuestions_WrapperAnswer__YAPa6","AnswerTitle":"TestQuestions_AnswerTitle__8lB3A","questionsText":"TestQuestions_questionsText__vc9Rb"};